module.exports = __webpack_public_path__ + "static/media/SelfCompassionAndAcceptance.2f1dda38.jpg";